/** Общие цифры/достижения бренда — используются на главной и на странице «Обо мне» */
export const SITE_STATS = {
  masterclassesCount: '70+ МК',
  experienceYears: '8+ лет опыта',
  studentsCount: '50 000+ рукодельниц',
  socialFollowers: '150 000+ подписчиков в соц.сетях',
  reviewsCount: '5 000+ положительных отзывов',
} as const;
